// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SintMaarten from '../_raw/flag/icon_flag_sint_maarten.png';

export default () => <img src={SintMaarten} alt="SintMaarten" />;
